import React, { useState, useRef, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/FirebaseAuthContext';
import Logo from '../ui/Logo';

interface LayoutProps {
  children: React.ReactNode;
}

const menuItems = [
  { name: 'Dashboard', path: '/dashboard', icon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-6 h-6">
      <g clipPath="url(#clip0_2517_2084)">
        <path opacity="0.3" d="M5 5H9V11H5V5ZM15 13H19V19H15V13ZM5 17H9V19H5V17ZM15 5H19V7H15V5Z" fill="currentColor"/>
        <path d="M3 13H11V3H3V13ZM5 5H9V11H5V5ZM13 21H21V11H13V21ZM15 13H19V19H15V13ZM13 3V9H21V3H13ZM19 7H15V5H19V7ZM3 21H11V15H3V21ZM5 17H9V19H5V17Z" fill="currentColor"/>
      </g>
      <defs>
        <clipPath id="clip0_2517_2084">
          <rect width="24" height="24" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  ) },
  { name: 'My Library', path: '/books/library', icon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-6 h-6">
      <g clipPath="url(#clip0_2521_2089)">
        <path opacity="0.3" d="M13 13L10 10.75L7 13V4H6V20H18V4H13V13Z" fill="currentColor"/>
        <path d="M18 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V4C20 2.9 19.1 2 18 2ZM9 4H11V9L10 8.25L9 9V4ZM18 20H6V4H7V13L10 10.75L13 13V4H18V20Z" fill="currentColor"/>
      </g>
      <defs>
        <clipPath id="clip0_2521_2089">
          <rect width="24" height="24" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  ) },
  { name: 'Currently Reading', path: '/books/reading', icon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-6 h-6">
      <g clipPath="url(#clip0_2522_2094)">
        <path opacity="0.3" d="M7 17.97L12 15.82L17 17.97V5H7V17.97Z" fill="currentColor"/>
        <path d="M17 3H7C5.9 3 5 3.9 5 5V21L12 18L19 21V5C19 3.9 18.1 3 17 3ZM17 17.97L12 15.83L7 17.97V5H17V17.97Z" fill="currentColor"/>
      </g>
      <defs>
        <clipPath id="clip0_2522_2094">
          <rect width="24" height="24" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  ) },
  { name: 'Discover', path: '/books/discover', icon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-6 h-6">
      <g clipPath="url(#clip0_2328_1235)">
        <path opacity="0.3" d="M17.1096 10.83L14.6396 10.62L13.4396 10.52L12.9696 9.41L11.9996 7.13L11.0296 9.41L10.5596 10.52L9.35965 10.62L6.88965 10.83L8.76965 12.46L9.67965 13.25L9.40965 14.42L8.83965 16.84L10.9696 15.56L11.9996 14.93L13.0296 15.56L15.1596 16.84L14.5896 14.42L14.3196 13.25L15.2296 12.46L17.1096 10.83Z" fill="currentColor"/>
        <path d="M22 9.24L14.81 8.63L12 2L9.19 8.63L2 9.24L7.46 13.97L5.82 21L12 17.27L18.18 21L16.54 13.97L22 9.24ZM14.59 14.42L15.15 16.83L13.03 15.55L12 14.93L10.97 15.55L8.85 16.83L9.41 14.42L9.68 13.24L8.77 12.45L6.89 10.82L9.36 10.61L10.56 10.51L11.03 9.4L12 7.13L12.97 9.42L13.44 10.53L14.64 10.63L17.11 10.84L15.23 12.47L14.32 13.26L14.59 14.42Z" fill="currentColor"/>
      </g>
      <defs>
        <clipPath id="clip0_2328_1235">
          <rect width="24" height="24" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  ) },
  { name: 'Book Club', path: '/books/book-club', icon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-6 h-6">
      <g clipPath="url(#clip0_2328_1224)">
        <path opacity="0.3" d="M19 17.13V10.18C16.9 10.56 14.95 11.53 13.36 13.01L12 14.28L10.64 13.01C9.05 11.53 7.1 10.56 5 10.18V17.13C7.53 17.47 9.94 18.43 12 19.96C14.07 18.44 16.47 17.47 19 17.13Z" fill="currentColor"/>
        <path opacity="0.3" d="M12 7C13.1046 7 14 6.10457 14 5C14 3.89543 13.1046 3 12 3C10.8954 3 10 3.89543 10 5C10 6.10457 10.8954 7 12 7Z" fill="currentColor"/>
        <path d="M16 5C16 2.79 14.21 1 12 1C9.79 1 8 2.79 8 5C8 7.21 9.79 9 12 9C14.21 9 16 7.21 16 5ZM10 5C10 3.9 10.9 3 12 3C13.1 3 14 3.9 14 5C14 6.1 13.1 7 12 7C10.9 7 10 6.1 10 5ZM3 19C6.48 19 9.64 20.35 12 22.55C14.36 20.36 17.52 19 21 19V8C17.52 8 14.36 9.35 12 11.55C9.64 9.35 6.48 8 3 8V19ZM5 10.18C7.1 10.56 9.05 11.53 10.64 13.01L12 14.28L13.36 13.01C14.95 11.53 16.9 10.56 19 10.18V17.13C16.47 17.47 14.07 18.43 12 19.95C9.94 18.43 7.53 17.46 5 17.12V10.18Z" fill="currentColor"/>
      </g>
      <defs>
        <clipPath id="clip0_2328_1224">
          <rect width="24" height="24" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  ) },
];

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { user, signOut } = useAuth();
  const location = useLocation();
  const isAuthPage = location.pathname === '/login' || location.pathname === '/signup';

  // Profile dropdown state
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  // Notifications dropdown state
  const [notifOpen, setNotifOpen] = useState(false);
  const notifRef = useRef<HTMLDivElement>(null);
  const notifications = [
    {
      icon: (
        <svg width="24" height="24" fill="none" stroke="#3B82F6" strokeWidth="2" viewBox="0 0 24 24"><rect x="4" y="4" width="16" height="16" rx="3" stroke="#3B82F6" strokeWidth="2" fill="#F3F8FF"/><path d="M8 8h8v8H8z" fill="#3B82F6"/></svg>
      ),
      message: 'You started reading "The Great Gatsby"',
      time: '2 hours ago',
    },
    {
      icon: (
        <svg width="24" height="24" fill="none" stroke="#22C55E" strokeWidth="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" stroke="#22C55E" strokeWidth="2" fill="#F3FCF7"/><path d="M8 12l2 2 4-4" stroke="#22C55E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
      ),
      message: 'You completed "To Kill a Mockingbird"',
      time: '2 hours ago',
    },
  ];

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setDropdownOpen(false);
      }
      if (notifRef.current && !notifRef.current.contains(event.target as Node)) {
        setNotifOpen(false);
      }
    }
    if (dropdownOpen || notifOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [dropdownOpen, notifOpen]);

  if (isAuthPage) {
    return <div className="min-h-screen bg-gray-50">{children}</div>;
  }

  return (
    <div className="min-h-screen flex bg-[#FCFAF3]">
      {/* Sidebar */}
      <aside className="w-[220px] bg-[#FCFAF3] border-r border-[#F2F2F2] flex flex-col px-4 min-h-screen fixed left-0 top-0 bottom-0 z-20">
        <div className="mt-8 mb-10 pl-2">
          <Logo />
        </div>
        <nav className="flex flex-col gap-2">
          {menuItems.map(item => {
            const isActive = location.pathname === item.path || (item.path === '/dashboard' && location.pathname === '/');
            return (
              <Link
                key={item.name}
                to={item.path}
                className={`flex items-center gap-3 px-4 py-3 rounded-lg font-medium text-sm transition-colors
                  ${isActive ? 'bg-[#FF6600] text-white shadow-sm' : 'text-[#232323] hover:bg-[#FFF3ED]'}
                `}
                style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}
              >
                {item.icon}
                {item.name}
              </Link>
            );
          })}
        </nav>
      </aside>
      {/* Main Content */}
      <main className="flex-1 w-full min-h-screen px-4 pt-0 ml-[220px]">
        {/* Dashboard Header Row */}
        {location.pathname === '/dashboard' && (
          <div className="flex items-center justify-between mt-6 mx-8" style={{minHeight: '64px'}}>
            <div>
              <h1 className="text-3xl font-bold text-gray-900" style={{fontFamily: 'Plus Jakarta Sans, sans-serif'}}>Your Dashboard</h1>
              <p className="text-gray-600 text-base mt-0.5" style={{fontFamily: 'Plus Jakarta Sans, sans-serif'}}>Track your reading progress</p>
            </div>
            <div className="flex items-center">
              {/* Notification Icon */}
              <div className="relative mr-6">
                <button
                  className="focus:outline-none w-8 h-8 flex items-center justify-center group"
                  onClick={() => setNotifOpen(v => !v)}
                >
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-8 h-8 transition duration-150 text-[#333] group-hover:text-[#FF6600] group-active:text-[#FF6600]"
                  >
                    <g clipPath="url(#clip0_2517_2079)">
                      <path opacity="0.3" d="M16.0003 8.66666C12.6803 8.66666 10.667 11.36 10.667 14.6667V22.6667H21.3337V14.6667C21.3337 11.36 19.3203 8.66666 16.0003 8.66666Z" fill="currentColor"/>
                      <path d="M15.9997 29.3333C17.4663 29.3333 18.6663 28.1333 18.6663 26.6667H13.333C13.333 28.1333 14.533 29.3333 15.9997 29.3333ZM23.9997 21.3333V14.6667C23.9997 10.5733 21.8263 7.14668 17.9997 6.24001V5.33334C17.9997 4.22668 17.1063 3.33334 15.9997 3.33334C14.893 3.33334 13.9997 4.22668 13.9997 5.33334V6.24001C10.1863 7.14668 7.99967 10.56 7.99967 14.6667V21.3333L5.33301 24V25.3333H26.6663V24L23.9997 21.3333ZM21.333 22.6667H10.6663V14.6667C10.6663 11.36 12.6797 8.66668 15.9997 8.66668C19.3197 8.66668 21.333 11.36 21.333 14.6667V22.6667Z" fill="currentColor"/>
                    </g>
                    <defs>
                      <clipPath id="clip0_2517_2079">
                        <rect width="32" height="32" fill="white"/>
                      </clipPath>
                    </defs>
                  </svg>
                </button>
                {notifOpen && (
                  <div ref={notifRef} className="absolute right-0 mt-2 w-96 bg-white rounded-xl shadow-xl z-50 p-0 border border-gray-100">
                    <div className="flex items-center gap-2 px-6 pt-5 pb-2">
                      <span className="inline-flex items-center justify-center w-5 h-5 rounded bg-[#E6FAF3]">
                        <svg width="16" height="16" fill="none" viewBox="0 0 16 16"><path d="M3 8.5L6.5 12L13 5.5" stroke="#22C55E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
                      </span>
                      <span className="text-sm font-semibold text-gray-900">Notifications</span>
                    </div>
                    <div className="px-4 pb-4">
                      {notifications.map((notif, idx) => (
                        <div key={idx} className="flex items-center gap-3 bg-[#F8FAFC] rounded-xl px-4 py-3 mb-3 last:mb-0">
                          <span>{notif.icon}</span>
                          <div>
                            <div className="text-sm text-gray-900 font-medium">{notif.message}</div>
                            <div className="text-xs text-gray-500 mt-0.5">{notif.time}</div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
              {/* Profile Dropdown */}
              <div className="relative" ref={dropdownRef}>
                <button
                  className="flex items-center justify-center w-8 h-8 focus:outline-none group"
                  onClick={() => setDropdownOpen(v => !v)}
                >
                  {/* Custom profile icon from public/profile.svg */}
                  <svg
                    width="32"
                    height="32"
                    viewBox="0 0 32 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-8 h-8 transition duration-150 text-[#333] group-hover:text-[#FF6600] group-active:text-[#FF6600]"
                  >
                    <g clipPath="url(#clip0_2331_1159)">
                      <path
                        opacity="0.3"
                        d="M15.9997 5.33334C10.1063 5.33334 5.33301 10.1067 5.33301 16C5.33301 18.6 6.26634 20.9733 7.81301 22.8267C10.0663 21.0667 12.9063 20 15.9997 20C19.093 20 21.933 21.0667 24.1863 22.8267C25.733 20.9733 26.6663 18.6 26.6663 16C26.6663 10.1067 21.893 5.33334 15.9997 5.33334ZM15.9997 17.3333C13.4263 17.3333 11.333 15.24 11.333 12.6667C11.333 10.0933 13.4263 8 15.9997 8C18.573 8 20.6663 10.0933 20.6663 12.6667C20.6663 15.24 18.573 17.3333 15.9997 17.3333Z"
                        fill="currentColor"
                      />
                      <path
                        d="M15.9993 2.66667C8.63935 2.66667 2.66602 8.64 2.66602 16C2.66602 23.36 8.63935 29.3333 15.9993 29.3333C23.3593 29.3333 29.3327 23.36 29.3327 16C29.3327 8.64 23.3593 2.66667 15.9993 2.66667ZM15.9993 26.6667C13.6793 26.6667 11.546 25.92 9.79935 24.6667C11.546 23.4133 13.6793 22.6667 15.9993 22.6667C18.3193 22.6667 20.4527 23.4133 22.1993 24.6667C20.4527 25.92 18.3193 26.6667 15.9993 26.6667ZM24.186 22.8267C21.9327 21.0667 19.0927 20 15.9993 20C12.906 20 10.066 21.0667 7.81268 22.8267C6.26602 20.9733 5.33268 18.6 5.33268 16C5.33268 10.1067 10.106 5.33334 15.9993 5.33334C21.8927 5.33334 26.666 10.1067 26.666 16C26.666 18.6 25.7327 20.9733 24.186 22.8267Z"
                        fill="currentColor"
                      />
                      <path
                        d="M15.9997 7.90667C13.4263 7.90667 11.333 10 11.333 12.5733C11.333 15.1467 13.4263 17.24 15.9997 17.24C18.573 17.24 20.6663 15.1467 20.6663 12.5733C20.6663 10 18.573 7.90667 15.9997 7.90667ZM15.9997 14.5733C14.893 14.5733 13.9997 13.68 13.9997 12.5733C13.9997 11.4667 14.893 10.5733 15.9997 10.5733C17.1063 10.5733 17.9997 11.4667 17.9997 12.5733C17.9997 13.68 17.1063 14.5733 15.9997 14.5733Z"
                        fill="currentColor"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_2331_1159">
                        <rect width="32" height="32" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </button>
                {dropdownOpen && (
                  <div className="absolute right-0 mt-2 w-48 bg-white border border-gray-200 rounded-lg shadow-lg z-30">
                    <div className="px-4 py-3 border-b border-gray-100">
                      <span className="block text-sm text-gray-900">{user?.email}</span>
                    </div>
                    <Link
                      to="/settings"
                      className="flex items-center gap-2 px-4 py-3 text-sm text-gray-700 hover:bg-gray-50"
                      onClick={() => setDropdownOpen(false)}
                    >
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
                        <circle cx="12" cy="12" r="3" stroke="currentColor" />
                        <path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 01-2.83 2.83l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09a1.65 1.65 0 00-1-1.51 1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09a1.65 1.65 0 001.51-1 1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06a1.65 1.65 0 001.82.33h.09A1.65 1.65 0 008 3.09V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51h.09a1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06a1.65 1.65 0 00-.33 1.82v.09a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z" stroke="currentColor" />
                      </svg>
                      Settings
                    </Link>
                    <button
                      onClick={signOut}
                      className="w-full text-left px-4 py-3 text-sm text-red-600 hover:bg-gray-50 rounded-b-lg"
                    >
                      Sign out
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        {/* Main Content */}
        {children}
      </main>
    </div>
  );
};

export default Layout;

// Add this global style for the orange filter
if (typeof window !== 'undefined') {
  const style = document.createElement('style');
  style.innerHTML = `
    .filter-orange {
      filter: brightness(0) saturate(100%) invert(54%) sepia(92%) saturate(749%) hue-rotate(353deg) brightness(104%) contrast(104%);
    }
  `;
  document.head.appendChild(style);
} 